import React from 'react';

const AdPoster2 = () => {
  return (
    <section className="py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="rounded-2xl overflow-hidden shadow-xl">
          <img
            src="https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=600&h=400&fit=crop"
            alt="Ceremonzy wedding services promotional image - Beautiful wedding ceremony setup"
            className="w-full h-64 object-cover"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default AdPoster2;